export default {
  allDecks: (state) => state.decks,
  decksLoading: (state) => state.loading
}
